import React, { useState } from "react";

import { processModuleProperties } from "services";

import { useCancelAsyncOnUnmount } from "utils";

import { MODULE_TYPE } from "consts";

import { AdminHead, AdminTable, Col, Link, Row, Message as message } from "components";

import { DownloadUploadModuleProperties } from "pages/admin/programs/components/DownloadUploadModuleProperties";

export const ModuleProperties = ({ module, list, updateData }) => {
  const [saving, setSaving] = useState(false);
  const signal = useCancelAsyncOnUnmount()();

  const processFile = (csv) => {
    setSaving(true);
    processModuleProperties({
      module: module.module,
      type: list.type,
      data: csv.data,
      signal,
    })
      .then((res) => {
        updateData();
        message({
          content: `The gremlins have successfully processed ${res.processedCount} rows. But could not process ${res.errorCount} rows`,
          icon: "gremlin",
        });
      })
      .finally(() => {
        setSaving(false);
      });
  };

  return (
    <>
      <AdminHead
        description={
          <>
            {module.type === MODULE_TYPE.FIELD && (
              <>
                Property upload for field modules has moved to the <Link to="/settings/calculations">calculation page</Link>.{"\n"}
                {"\n"}
              </>
            )}
            When updating lists of properties, the CSV file that you upload must contain the same structure as the downloadable CSV (including header and
            quantity of columns). Items will be matched by ID number, which you can leave blank for new additions. Any existing items not included in your CSV
            upload will not be changed.
            {"\n"}
            {"\n"}
            {module.type === MODULE_TYPE.FARM && list.type === "methane_reducing_feeds" && (
              <>Methane reducing feeds are added in the following way: if a feed reduces the methane to 80% of normal levels, add "80" as the amount</>
            )}
          </>
        }
        extra={module.type === MODULE_TYPE.FARM && <DownloadUploadModuleProperties list={list} module={module} saving={saving} onUpload={processFile} />}
      />
      <Row>
        <Col>
          <AdminTable dataSource={list.items} type={list.type} />
        </Col>
      </Row>
    </>
  );
};
